// $(document).on("click",".field_set-optionList",function() {
//   if($(this).hasClass('it_on')){
//     $(this).removeClass('it_on');
//   }else{
//     $(this).addClass('it_on');
//   }
// });


// Every picker that size_option.liquid renders (Size, Letter, Gift, any custom
// option) shares this markup; scoping the toggle to .cd-size left the others
// unable to open (Letter picker on the initial decals).
$(document).on("click", ".custom-dropdown .field_set-optionList", function(e) {
  e.stopPropagation();

  $(this).toggleClass("it_on");
});

$(document).on("click", function(e) {
  if (!$(e.target).closest(".custom-dropdown.cd-size .dropdown-list").length) {
    $(".field_set-optionList").removeClass("it_on");
  }
});



$(document).on("click", ".dropdown_list li", function () {
  
  var value = $(this).data("title"); // e.g. "B1"
  var fullText = $(this).text().trim(); // e.g. "B1: 70x100 cm"

  // Highlight the selected list item
  $(this).siblings("li").removeClass("text_select");
  $(this).addClass("text_select");

  // Find the correct wrapper scope
  var $fieldSet = $(this).closest(".field_set-optionList");
  var $variantWrapper = $(this).closest(".variant-wrapper");

  // Highlight the matching .variant_select-product
  $fieldSet.find(".variant_select-product").removeClass("active_seclet");
  $fieldSet
    .find('.variant_select-product[data-title="' + value + '"]')
    .addClass("active_seclet");

  // Find the matching variant input (handle cases like "B1" vs "B1: 70x100 cm")
  var $radioInput = $variantWrapper
    .find(".variant-input-wrap .variant-input")
    .filter(function () {
      var dataValue = $(this).data("value");
      return dataValue === value || dataValue.startsWith(value + ":");
    })
    .find('input[type="radio"]');

  if ($radioInput.length) {
    // Set radio checked and trigger Shopify change event
    $radioInput.click();
    $radioInput.prop("checked", true).trigger("change");

    // Also trigger click on label for styling consistency
    $radioInput.siblings("label").trigger("click");
    $fieldSet.toggleClass("it_on");
  }

  // ✅ Update the visible selected option text (like “A0” → “B1: 70x100 cm”)
  // Scoped to this wrapper so the quick-shop modal (cloned ids get a -modal
  // suffix) updates its own label, not the main page's.
  $variantWrapper.find('[id^="selected-option-value-"]').first().text(fullText);

  // Scope everything to this product section: the quick-shop modal clones the
  // whole block area, so global selectors would read/write the main page's
  // form (wrong product id in the cart).
  var $productScope = $(this).closest(".product-section");
  if (!$productScope.length) $productScope = $(document);

  // Wait for variant updates to complete
  setTimeout(function () {
    var selectedOptions = [];

    $productScope.find(".variant-input-wrap").each(function () {
      var checked = $(this).find('input[type="radio"]:checked');
      if (checked.length) {
        selectedOptions.push(checked.val().trim());
      }
    });

    var productJsonEl = $productScope.find(
      '[type="application/json"][data-product-json]'
    )[0];
    if (!productJsonEl) return;

    var productData = JSON.parse(productJsonEl.textContent);

    var matchedVariant = productData.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt.trim() === selectedOptions[i];
      });
    });

    if (matchedVariant) {
      $productScope.find('input[name="id"]').val(matchedVariant.id);
    }

  }, 30);



  
});









$(document).ready(function () {
  
  // [data-fancybox="preview"]
  // $('.product-image-main a.fancybox').fancybox({
  //   // Enable zoom feature
  //         buttons: [
  //         "slideShow",
  //         "thumbs",
  //         "zoom",
  //         "close"
  //       ],
  //       loop: false,
  //       protect: false,
  //       width: 750,
  //       height: 750,
  //       // Callback function triggered before zoom
  // });

        function initPopup() {
          var screenWidth = window.innerWidth;
          var $productListInner = $('.product-image-main a.fancybox');
          if (screenWidth <= 740) {
             $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                width: 750,
        height: 750,
                  // Callback function triggered before zoom
            });
          }else{
            $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                  // Callback function triggered before zoom
            });
          }
        }

        initPopup();
        $(window).on('resize', initPopup);
})

$( document ).ready(function() {
  if(window.location.href.includes('/products/')){
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
  }
});


$(document).ready(function() {
    function checkSelectedFrame() {
                var selectedSlide = $('.product-main-slide.is-selected');
                if (selectedSlide.attr('data-frame') === 'frame') {
                   $('.grid--product-images--partial').attr('data-enable-frame', true);
                } else {
                    $('.grid--product-images--partial').attr('data-enable-frame', false);
                }
            }
  var targetNode = document.querySelector('.product-slideshow .flickity-slider'); // Corrected this line
  
  if (targetNode) { 
    var observer = new MutationObserver(function(mutationsList, observer) {
      
      for (var mutation of mutationsList) {
        if (mutation.attributeName === 'class') {
        // checkSelectedFrame();
          break;
        }
      }
    });

    var config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetNode, config);
  } 
  
    var $drawerInner = $('.drawer__inner');
    var $shipInsurance = $('.drawer__footer');
    var isShown = true;
  
    $drawerInner.on('scroll', function () {
        var scrollTop = $drawerInner.scrollTop();
        var scrollHeight = $drawerInner.prop('scrollHeight');
        var innerHeight = $drawerInner.innerHeight();
        var distanceFromBottom = scrollHeight - (scrollTop + innerHeight);

        if (scrollTop > 10 && distanceFromBottom > 100) {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideUp()
            // $('.drawer__footer').addClass('drawer__footer--fixed');
          if (isShown) {
            isShown = false;
          }
        } else {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideDown()
            // $('.drawer__footer').removeClass('drawer__footer--fixed');
          if (!isShown) {
             isShown = true;
          }
        }
    });
});


// frames and canvas logic starts here

// document.addEventListener("DOMContentLoaded", function () {
//     const radioCanvas = document.getElementById("radio-canvas");
//     const radioPrint = document.getElementById("radio-print");
//     const selectedOptionFrame = document.getElementById("selected-option-value-frame");

//     const frameVariants = document.querySelectorAll(".amr-Frame .variant-input[data-value]:not([data-value*='Canvas'])");
//     const canvasVariants = document.querySelectorAll(".amr-Frame .variant-input-wrap  [data-value*='Canvas'], .amr-Frame .variant-input-wrap [data-value*='Floating']");
//     const unframedVariant = document.querySelector(".variant-input[data-value='Unframed']");
//     const line_item_parent_effect = document.querySelector(".line-item-parent-effect");
//     let noBorderRadio = document.querySelector(".fk-bcpo-radios input[type='radio'][value='No Border']");
//     let border_option = document.querySelector(".fk-line-item-parent-effect");
//     let am_border_option = document.querySelector(".amr-Border");
//     const canvasLabelText = "Stretched Canvas - No Outside Frame"; // Fixed text for Canvas mode
//     let isCanvasActive = false; // Flag to track whether Canvas mode is active

//     function selectVariant(variant) {
//         if (variant) {
//             const input = variant.querySelector("input");
//             input.checked = true;
//             input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change event
            
//             // If Canvas is active and Unframed is selected, show fixed text
//             // if (isCanvasActive && variant.dataset.value === "Unframed") {
//             //     updateSelectedOption(canvasLabelText);
//             // } else if (!isCanvasActive) {
//             //     updateSelectedOption(variant.dataset.value);
//             // }
//         }
//     }

//     // function showFrames() {
//     //     isCanvasActive = false; // Disable Canvas mode
//     //     frameVariants.forEach(variant => (variant.style.display = "inline-block"));
//     //     canvasVariants.forEach(variant => (variant.style.display = "none"));
//     //     unframedVariant.style.display = "inline-block"; // Ensure Unframed is shown
//     //     selectVariant(unframedVariant);
//     //     if(border_option){
//     //       border_option.style.display = "flex";
//     //     }
//     //    $('.hidden_canvas_frame').val('');
//     // }
//   function showFrames() {
//     isCanvasActive = false;
//     frameVariants.forEach(variant => (variant.style.display = "inline-block"));
//     // canvasVariants.forEach(variant => (variant.style.display = "none"));
//     if (unframedVariant) {
//       unframedVariant.style.display = "inline-block";
//     }
//     if (border_option) {
//       border_option.style.display = "flex";
//       am_border_option.style.display = "block";
//     }
//     $('.hidden_canvas_frame').val('');
//     const firstVisibleFrame = $('.amr-Frame .variant-input.var-input')
//       .filter(function () {
//         return $(this).css('display') === 'inline-block';
//       })
//       .first()
//       .find('input[type="radio"]');
//     if (firstVisibleFrame.length) {
//       firstVisibleFrame.click();
//     }
//   }
//     function showFramesLoad() {
//     isCanvasActive = false;
//     frameVariants.forEach(variant => (variant.style.display = "inline-block"));
//     // canvasVariants.forEach(variant => (variant.style.display = "none"));
//     if (unframedVariant) {
//       unframedVariant.style.display = "inline-block";
//     }
//     if (border_option) {
//       border_option.style.display = "flex";
//       am_border_option.style.display = "block";
//     }
//     $('.hidden_canvas_frame').val('');
//   }

//   function showCanvas() {
//       isCanvasActive = true;
//       frameVariants.forEach(variant => (variant.style.display = "none"));
//       // canvasVariants.forEach(variant => (variant.style.display = "inline-block"));
//       selectVariant(unframedVariant);

//       if (noBorderRadio && !noBorderRadio.checked) {
//         noBorderRadio.checked = true;
//         noBorderRadio.dispatchEvent(new Event("change", { bubbles: true }));
//         noBorderRadio.click();
//       }

//       if (border_option) {
//         border_option.style.display = "none";
//         am_border_option.style.display = "none";
//       }

//       const firstVisibleCanvasVariant = $('.amr-Frame .variant-input.var-input')
//         .filter(function () {
//           return $(this).css('display') === 'inline-block';
//         })
//         .first()
//         .find('input[type="radio"]');

//       if (firstVisibleCanvasVariant.length) {
//         firstVisibleCanvasVariant.click();
//       }
//     }



//     function updateSelectedOption(value) {
//       console.log('testr');
//         if (selectedOptionFrame) {
//             selectedOptionFrame.textContent = value;
//         }
//     }

//     // Handle variant clicks to update label
//     document.querySelectorAll(".variant-input").forEach(variant => {
//         variant.addEventListener("click", function () {
//             if (isCanvasActive && this.dataset.value === "Unframed") {
//                 updateSelectedOption(canvasLabelText);
//             } else if (!isCanvasActive) {
//                 selectVariant(this);
//             }
//         });
//     });

//     showFramesLoad(); // Default state

//     if (radioCanvas) {
//         radioCanvas.addEventListener("click", showCanvas);
//     }
//     if (radioPrint) {
//         radioPrint.addEventListener("click", showFrames);
//     }






// });


document.addEventListener("DOMContentLoaded", function () {
    const radioCanvas = document.getElementById("radio-canvas");
    const radioPrint = document.getElementById("radio-print");
    const selectedOptionFrame = document.getElementById("selected-option-value-frame");

    // Normal framed options
    const frameVariants = document.querySelectorAll(
        ".amr-Frame .variant-input[data-value]:not([data-value*='Canvas']):not([data-value*='Floating'])"
    );

    // Canvas + Floating options
    const canvasVariants = document.querySelectorAll(
        ".amr-Frame .variant-input[data-value*='Canvas'], " +
        ".amr-Frame .variant-input[data-value*='Floating']"
    );

    const unframedVariant = document.querySelector(
        ".amr-Frame .variant-input[data-value='Unframed']"
    );

    const line_item_parent_effect = document.querySelector(".line-item-parent-effect");
    const noBorderRadio = document.querySelector(
        ".fk-bcpo-radios input[type='radio'][value='No Border']"
    );
    const border_option = document.querySelector(".fk-line-item-parent-effect");
    const am_border_option = document.querySelector(".amr-Border");

    const canvasLabelText = "Stretched Canvas - No Outside Frame";

    let isCanvasActive = false;


    function selectVariant(variant) {
        if (!variant) return;

        const input = variant.querySelector("input");

        if (input) {
            input.checked = true;
            input.dispatchEvent(
                new Event("change", { bubbles: true })
            );
        }
    }
 

    function updateSelectedOption(value) {
        if (selectedOptionFrame) {
            selectedOptionFrame.textContent = value;
        }
    }


    // PRINT / NORMAL FRAMES
    function showFrames() {
        isCanvasActive = false;

        // Show normal frames
        frameVariants.forEach(variant => {
            variant.style.display = "inline-block";
        });

        // Hide Canvas + Floating
        canvasVariants.forEach(variant => {
            variant.style.display = "none";
        });

        // Show Unframed
        // if (unframedVariant) {
        //     unframedVariant.style.display = "inline-block";
        // }

        // Show border options
        if (border_option) {
            border_option.style.display = "flex";
        }

        if (am_border_option) {
            am_border_option.style.display = "block";
        }

        $(".hidden_canvas_frame").val("");

        // Select first visible normal frame
        const firstVisibleFrame = $(".amr-Frame .variant-input.var-input")
            .filter(function () {
                return $(this).css("display") === "inline-block";
            })
            .first()
            .find("input[type='radio']");

        if (firstVisibleFrame.length) {
            firstVisibleFrame.click();
        }
    }


    // INITIAL LOAD - PRINT
    function showFramesLoad() {
        isCanvasActive = false;

        frameVariants.forEach(variant => {
            variant.style.display = "inline-block";
        });

        canvasVariants.forEach(variant => {
            variant.style.display = "none";
        });

        // if (unframedVariant) {
        //     unframedVariant.style.display = "inline-block";
        // }

        if (border_option) {
            border_option.style.display = "flex";
        }

        if (am_border_option) {
            am_border_option.style.display = "block";
        }

        $(".hidden_canvas_frame").val("");
    }


    // CANVAS / FLOATING
    function showCanvas() {
        isCanvasActive = true;

        // Hide normal frames
        frameVariants.forEach(variant => {
            variant.style.display = "none";
        });

        // Show Canvas + Floating
        canvasVariants.forEach(variant => {
            variant.style.display = "inline-block";
        });

        // Unframed is required for Canvas
        // if (unframedVariant) {
        //     unframedVariant.style.display = "inline-block";
        //     selectVariant(unframedVariant);
        // }

        // Force No Border
        if (noBorderRadio && !noBorderRadio.checked) {
            noBorderRadio.checked = true;
            noBorderRadio.dispatchEvent(
                new Event("change", { bubbles: true })
            );
            noBorderRadio.click();
        }

        // Hide border options
        if (border_option) {
            border_option.style.display = "none";
        }

        if (am_border_option) {
            am_border_option.style.display = "none";
        }

        // Select first visible Canvas/Floating option
        const firstVisibleCanvasVariant = $(".amr-Frame .variant-input.var-input")
            .filter(function () {
                return $(this).css("display") === "inline-block";
            })
            .first()
            .find("input[type='radio']");

        if (firstVisibleCanvasVariant.length) {
            firstVisibleCanvasVariant.click();
        }
    }


    // Variant click handling
    document.querySelectorAll(".amr-Frame .variant-input").forEach(variant => {

        variant.addEventListener("click", function () {

            // Canvas/Floating mode
            if (isCanvasActive) {

                if (
                    this.dataset.value === "Unframed" ||
                    this.dataset.value.includes("Canvas") ||
                    this.dataset.value.includes("Floating")
                ) {
                    if (this.dataset.value === "Unframed") {
                        updateSelectedOption(canvasLabelText);
                    }
                }

                return;
            }

            // Normal Print mode
            selectVariant(this);
        });
    });


    // Default state
    showFramesLoad();


    // Canvas button
    if (radioCanvas) {
        radioCanvas.addEventListener("click", showCanvas);
    }


    // Print button
    if (radioPrint) {
        radioPrint.addEventListener("click", showFrames);
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const frameInputs = document.querySelectorAll('input[name="Frame"]');
  const borderInputs = document.querySelectorAll('input[name="Border Options"]');
  const imageGrid2 = document.querySelector(".frame-orientation-wrapper");

  function updateFrameAttributesFrame(selectedInput) {
   setTimeout(() => {
    // Scope to the surrounding product section so the quick-shop modal's
    // cloned picker updates the modal's own gallery, not the main page's.
    const scope = selectedInput?.closest?.(".product-section") || document;
    const inQuickShop = !!selectedInput?.closest?.(".modal--quick-shop");
    const selectedFrame = selectedInput?.value || scope.querySelector('input[name="Frame"]:checked')?.value;
    const selectedBorder = scope.querySelector('.amr-Border .fk-selector-wrapper input:checked')?.value
      || scope.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
    if (selectedFrame && selectedBorder) {
      const imageGrid = scope.querySelector(".grid--product-images--partial");
      // The live-preview integration keeps its .frame-orientation-wrapper
      // outside the product section — main-page changes must still update it
      // globally (only quick-shop modal changes stay scoped).
      const orientationWrap = scope.querySelector(".frame-orientation-wrapper")
        || (!inQuickShop ? document.querySelector(".frame-orientation-wrapper") : null);

      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
        imageGrid.setAttribute("data-frame", selectedFrame);
      }
      if (orientationWrap) {
        orientationWrap.setAttribute("data-enable-frame", true);
        orientationWrap.setAttribute("data-border", selectedBorder);
        orientationWrap.setAttribute("data-frame", selectedFrame);
      }
    }
    }, 500);
  }

  // Delegated so the quick-shop modal's cloned frame inputs work too
  document.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches('input[name="Frame"]')) {
      updateFrameAttributesFrame(e.target);
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.matches && e.target.matches('.fk-selector-wrapper input')) {
      updateFrameAttributesBorder(e.target);
    }
  });


 function updateFrameAttributesBorder(selectedInput) {
    const selectedBorder = selectedInput.value;
    if (selectedBorder) {
      const scope = selectedInput.closest?.(".product-section") || document;
      const inQuickShop = !!selectedInput.closest?.(".modal--quick-shop");
      const imageGrid = scope.querySelector(".grid--product-images--partial");
      const orientationWrap = scope.querySelector(".frame-orientation-wrapper")
        || (!inQuickShop ? document.querySelector(".frame-orientation-wrapper") : null);
      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
      }
      if (orientationWrap) {
        orientationWrap.setAttribute("data-enable-frame", true);
        orientationWrap.setAttribute("data-border", selectedBorder);
      }
    }
  }







  // Run once on page load
  updateFrameAttributesFrame();
});


document.addEventListener('click', function(evt) {
  var removeLink = evt.target.closest('.cart__remove a');
  if (!removeLink) {
    return;
  }

  evt.preventDefault();

  if (!window.theme || !theme.cart || typeof theme.cart.removeItem !== 'function') {
    console.error('theme.cart.removeItem is not available — check that theme.js loaded before custom.js');
    return;
  }

  var cartItem = removeLink.closest('.cart__item');
  if (!cartItem) {
    return;
  }

  var key = cartItem.dataset.key;
  var hasEnhance = cartItem.dataset.enhance === 'Yes';

  theme.cart.removeItem(key, hasEnhance).then(function() {
    document.dispatchEvent(new CustomEvent('cart:build'));

    theme.cart.getCart().then(function(cart) {
      document.querySelectorAll('.shipping-progress-wrapper').forEach(function(el) {
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      document.dispatchEvent(new CustomEvent('ajaxProduct:removed', {
        detail: { cart: cart }
      }));
    });
  });
});








$(document).on("click", ".upsell-atc", function() {
  var $btn = $(this);
  var ID = $btn.data('id');

  $btn.addClass('loading').prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
    dataType: 'json', 
    success: function (data) { 
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      $btn.closest('.product-set-wrapper').hide();
      $btn.removeClass('loading').prop('disabled', false);
      if ($('.drawer__footer .product-set-wrapper:visible').length === 0) {
        $('.custom-accordion').hide();
    }

    },
    error: function() {
      $btn.removeClass('loading').prop('disabled', false);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".view-properties-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      const key = this.getAttribute("data-item-key");
      document.getElementById("properties-" + key).style.display = "block";
    });
  });

  document.querySelectorAll(".close-modal").forEach(closeBtn => {
    closeBtn.addEventListener("click", function () {
      this.closest(".properties-modal").style.display = "none";
    });
  });

  // Close modal on outside click
  window.addEventListener("click", function (e) {
    if (e.target.classList.contains("properties-modal")) {
      e.target.style.display = "none";
    }
  });
});




// $(document).ready(function() {
//   // Wait for variant inputs to exist
//   const checkFirstOption = setInterval(() => {
//     const firstOption = $('.variant-input-wrap.size_opt input[type="radio"]').first();
//     if (firstOption.length) {
//         $('.variant-input-wrap.size_opt label').click();
//       firstOption.trigger('click');
//       clearInterval(checkFirstOption);
//     }
//   }, 200);
// });





function initFkBorderSync() {
  // Border options UI is radios-only: the White Border dropdown and the
  // "Border Options: <value>" label line are no longer rendered
  // (snippets/size_option.liquid), and the BORDER OPTIONS heading stays
  // visible. Radio events are delegated so the quick-shop modal's cloned
  // markup works too, and everything is scoped to the surrounding
  // .product-section so modal and page never write into each other's form.
  document.addEventListener("change", function (e) {
    if (!e.target.matches || !e.target.matches(".fk-bcpo-radios input[type='radio']")) return;
    const fkRadio = e.target;
    const scope = fkRadio.closest(".product-section") || document;
    const value = fkRadio.value.trim();

    // Map fake radio text -> real variant value ("White Border" -> "With White Border")
    const realValue = value === "White Border" ? "With White Border" : value;

    const labelValue = fkRadio.closest(".fk-selector-wrapper")?.querySelector(".fk-bcpo-value");
    if (labelValue) labelValue.textContent = value;

    // Sync with the real Shopify variant input in the same product section
    const realRadio = scope.querySelector(
      `.variant-input-wrap input[type='radio'][value="${CSS.escape(realValue)}"]`
    );
    if (realRadio && !realRadio.checked) {
      realRadio.checked = true;
      realRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  function applyDefault(scope) {
    const defaultRadio = scope.querySelector(
      ".fk-bcpo-radios input[type='radio'][value='No Border']"
    );
    if (defaultRadio && !defaultRadio.checked) {
      defaultRadio.checked = true;
      defaultRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Default: auto-select "No Border" on the main page
  applyDefault(document);

  // Same default when a quick-view modal finishes loading its blocks
  document.addEventListener("quickview:loaded", function (e) {
    const modal = document.getElementById("QuickShopModal-" + e.detail.productId);
    if (modal) applyDefault(modal);
  });
}

// Run once on load
document.addEventListener("DOMContentLoaded", initFkBorderSync);







/* Quick-view (quick-shop modal) Material switch - 2026-09-25.
   The Fine Art Print / Canvas switch (above, and in snippets/print-options.liquid)
   binds #radio-canvas once at DOMContentLoaded, so it only ever drives the MAIN
   product. Quick-view markup arrives later (ids suffixed -modal): tapping Canvas
   there left the paper frames showing and the canvas frames hidden (theme.css
   hides [data-value*="Canvas"] with !important). This mirrors the main page's
   behaviour, scoped to the modal's own .product-section, via ONE delegated
   listener: show the canvas frames (inline !important, as the main page does),
   hide borders + pin No Border, hide sizes canvas is not made in (read from the
   modal's own product JSON) and move off one if selected, then pick the first
   canvas frame (Stretched, Timber, White, Black - the main page's order).
   Switching back to Print restores the size the shopper had. */
(function () {
  if (window.__smwModalMaterial) return;
  window.__smwModalMaterial = true;
  var isCanvasVal = function (v) { return /Canvas|Floating/.test(v || ''); };
  /* 2026-09-28: size values are "A3" on some products and "B0: 100x141 cm" on others, while the
     dropdown's data-title is always the part before the colon - compare on that, or B1/B0 get
     hidden for canvas and picking them leaves the dropdown head blank. */
  var sizeKey = function (v) { return String(v || '').split(':')[0].trim(); };
  var CANVAS_ORDER = ['Stretched Canvas', 'Timber Canvas Floating Frame', 'White Canvas Floating Frame', 'Black Canvas Floating Frame'];

  function canvasSizes(section) {
    if (section.__smwCanvasSizes) return section.__smwCanvasSizes;
    var set = {};
    try {
      var el = section.querySelector('script[data-product-json]');
      var p = JSON.parse(el.textContent);
      var names = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); });
      var si = names.findIndex(function (n) { return n.indexOf('size') > -1; });
      var fi = names.findIndex(function (n) { return n.indexOf('frame') > -1; });
      (p.variants || []).forEach(function (v) {
        if (si > -1 && fi > -1 && isCanvasVal(v.options[fi])) set[sizeKey(v.options[si])] = 1;
      });
    } catch (e) {}
    return (section.__smwCanvasSizes = set);
  }
  function show(el, on) {
    if (on) el.style.setProperty('display', el.tagName === 'LI' ? 'list-item' : 'inline-block', 'important');
    else el.style.setProperty('display', 'none', 'important');
  }
  function currentSize(section) {
    var r = section.querySelector('.amr-Size input[name="Size"]:checked');
    return r ? r.value : null;
  }
  function selectSize(section, title) {
    var k = sizeKey(title);
    var radio = Array.prototype.find.call(section.querySelectorAll('.amr-Size input[name="Size"]'), function (r) { return sizeKey(r.value) === k; });
    if (!radio) return;
    section.querySelectorAll('.amr-Size .variant_select-product').forEach(function (d) { d.classList.toggle('active_seclet', sizeKey(d.dataset.title) === k); });
    section.querySelectorAll('.amr-Size .dropdown_list li').forEach(function (li) { li.classList.toggle('text_select', sizeKey(li.dataset.title) === k); });
    radio.click();
  }
  function selectFrame(section, value) {
    var input = section.querySelector('.amr-Frame input[name="Frame"][value="' + value + '"]');
    if (input && !input.checked) input.click();
    return !!input;
  }

  function apply(section, canvas, label) {
    var sizes = canvasSizes(section);
    var hasSizes = Object.keys(sizes).length > 0;

    section.querySelectorAll('.amr-Frame .variant-input[data-value]').forEach(function (v) {
      show(v, isCanvasVal(v.dataset.value) === canvas);
    });
    section.querySelectorAll('.amr-Border, .fk-line-item-parent-effect').forEach(function (el) {
      el.style.display = canvas ? 'none' : '';
    });
    section.querySelectorAll('label.lbl-print, label.lbl-canvas').forEach(function (l) {
      l.classList.toggle('active', l.classList.contains(canvas ? 'lbl-canvas' : 'lbl-print'));
    });
    section.querySelectorAll('.craft-variant-lbl').forEach(function (l) {
      var v = label || (canvas ? 'Canvas' : 'Fine Art Print');
      if (l.textContent.trim() !== v) l.textContent = v;
    });

    // Sizes: hide the ones canvas is not made in; restore them for print.
    section.querySelectorAll('.amr-Size .variant_select-product, .amr-Size .dropdown_list li, .amr-Size .variant-input[data-value]').forEach(function (el) {
      var title = el.dataset.title || el.dataset.value;
      if (canvas && hasSizes && !sizes[sizeKey(title)]) show(el, false);
      else el.style.removeProperty('display');
    });

    if (canvas) {
      var noBorder = section.querySelector(".amr-Border input[type='radio'][value='No Border'], .fk-bcpo-radios input[type='radio'][value='No Border']");
      if (noBorder && !noBorder.checked) noBorder.click();
      var size = currentSize(section);
      if (hasSizes && size && !sizes[sizeKey(size)]) {
        section.dataset.smwPrintSize = size;
        var first = Array.prototype.find.call(section.querySelectorAll('.amr-Size input[name="Size"]'), function (r) { return sizes[sizeKey(r.value)]; });
        if (first) selectSize(section, first.value);
      }
      var cur = section.querySelector('.amr-Frame input[name="Frame"]:checked');
      if (!cur || !isCanvasVal(cur.value)) {
        CANVAS_ORDER.some(function (f) { return selectFrame(section, f); });
      }
    } else {
      var hc = section.querySelector('.hidden_canvas_frame');
      if (hc) hc.value = '';
      if (section.dataset.smwPrintSize) { selectSize(section, section.dataset.smwPrintSize); delete section.dataset.smwPrintSize; }
      var cf = section.querySelector('.amr-Frame input[name="Frame"]:checked');
      if (!cf || isCanvasVal(cf.value)) {
        var firstPrint = Array.prototype.find.call(section.querySelectorAll('.amr-Frame input[name="Frame"]'), function (r) { return !isCanvasVal(r.value); });
        if (firstPrint) firstPrint.click();
      }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'properties[Material]' || !/-modal$/.test(t.id || '')) return;
    var section = t.closest('.product-section');
    if (!section) return;
    apply(section, t.id.indexOf('radio-canvas') === 0, t.value);
  });
})();


/* Canvas-only products - 2026-09-28.
   A product with custom.enable_canvas set and custom.enable_print EMPTY renders only
   the Canvas tile, already checked. The Material switch above always starts in print
   mode (showFramesLoad hides every Canvas / Floating frame) and only enters canvas mode
   when #radio-canvas is CLICKED, which never happens when it is the only choice - so the
   frame row loaded empty. Enter canvas mode once on load instead. theme.css hides
   [data-value*="Canvas"] frames with !important and showCanvas() writes display without
   it, so the frames are revealed with !important before and after. Deliberately no
   'change' event: that handler (print-options.liquid) would hide every size missing from
   the block's canvas_enable_on list (A3-B0), i.e. all the square sizes. */
document.addEventListener('DOMContentLoaded', function () {
  var canvas = document.getElementById('radio-canvas');
  if (!canvas || document.getElementById('radio-print') || !canvas.checked) return;
  var section = canvas.closest('.product-section') || document;
  function reveal() {
    section.querySelectorAll(".amr-Frame .variant-input[data-value*='Canvas'], .amr-Frame .variant-input[data-value*='Floating']")
      .forEach(function (el) { el.style.setProperty('display', 'inline-block', 'important'); });
  }
  reveal();
  canvas.click();
  reveal();
});
